/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
import * as __WEBPACK_EXTERNAL_MODULE__google_engine_mjs_cb73cff1__ from "./google-engine.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__bing_engine_mjs_2296ac5f__ from "./bing-engine.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__baidu_engine_mjs_6ad6638c__ from "./baidu-engine.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__sogou_engine_mjs_29532a32__ from "./sogou-engine.mjs";
function getSearchEngine(engine) {
    switch(engine){
        case 'google':
            return new __WEBPACK_EXTERNAL_MODULE__google_engine_mjs_cb73cff1__.GoogleSearchEngine();
        case 'bing':
            return new __WEBPACK_EXTERNAL_MODULE__bing_engine_mjs_2296ac5f__.BingSearchEngine();
        case 'baidu':
            return new __WEBPACK_EXTERNAL_MODULE__baidu_engine_mjs_6ad6638c__.BaiduSearchEngine();
        case 'sogou':
            return new __WEBPACK_EXTERNAL_MODULE__sogou_engine_mjs_29532a32__.SogouSearchEngine();
        default:
            return new __WEBPACK_EXTERNAL_MODULE__google_engine_mjs_cb73cff1__.GoogleSearchEngine();
    }
}
export { getSearchEngine };

//# sourceMappingURL=get-search-engine.mjs.map